import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './addNewQuote.scss';
import { useAuth } from '@/lib/auth'
import { default as ReactSelect, components } from 'react-select';
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { ReactComponent as Statusicon } from '@/assets/steam/funnel-frame.svg';
import { ReactComponent as LastCoverageIcon } from '@/assets/steam/last-coverage.svg';
import { ReactComponent as Coverageicon } from '@/assets/steam/coverage-frame.svg';
import { ReactComponent as ProductIcon } from '@/assets/steam/product.svg';
import Utils from '@/utils/util';
import { ModalFooter } from 'react-bootstrap';
import DatePicker, { DayRange } from 'react-modern-calendar-datepicker';
import Dropdown from 'react-bootstrap/Dropdown';
import { ReactComponent as Calendericon } from '@/assets/steam/calender-frame.svg';
import { ReactComponent as Deleteicon } from '@/assets/steam/delete-red.svg';
import { useGetUsersList } from '@/features/users/api/getProducts';
import { User } from '@/types';
import { useGetFunnelStagess } from '../api/getStages';
import moment from 'moment';
import { Funnel, Group } from '../types/indes';
import { useGetProductList } from '@/features/product/api/getProduct';
import { Product } from '@/features/product/types/indes';
import { useCreateQuote } from '../api/quotesApi';
import { showNotification } from '@/utils/notificationUtils';

const AddQuotesDialog: VFC<{
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    funnetType?: any
    selectedFunnel?:any;
    productList?:any;
    editingQuote?: any;
}> = ({ open, onClose, onConfirm, funnetType , selectedFunnel,productList, editingQuote}) => {


    const { user } = useAuth();
    const [usersList, setUsersList] = useState<User[]>([]);
    const useCreateQuoteMutation = useCreateQuote();
    const selectRef = useRef<HTMLDivElement | null>(null); 
    const selectRef1 = useRef<HTMLDivElement | null>(null); 
    const [otherTerms, setOtherTerms] = useState<any>('');
    const [advPercent, setAdvPercent] = useState<any>('50');
    const [pdaPercent, setPdaPercent] = useState<any>('25');
    const [fnfPercent, setFnfPercent] = useState<any>('25');
    const [fnfTimeline, setFnfTimeline] = useState<any>('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownOpen1, setDropdownOpen1] = useState(false);
    const [funnelStages, setFuneelStages] = useState<[]>([]);
    const [selectedFunnelDetails, setselectedFunnelDetails] = useState<Funnel>()
    const [selectedDate, setSelectedDate] = useState<any>();
    const [productDetails, setProductDetails] = useState<Group[]>([]);
    //const [productList, setProductList] = useState<Product[]>([]);
    const useGetUsersMutation = useGetProductList();
    const [userData, setUserData] = useState<any>({
        title: '',
        requestPrice: '',
        paymentterms: ''
    } );

    const [dropdownOpenStates1, setDropdownOpenStates1] = useState(Array(productDetails.length).fill(false));
    const selectRefs1 = useRef([]);
    selectRefs1.current = productDetails.map((_, index) => selectRefs1.current[index] || React.createRef());

    const [dropdownOpenStates, setDropdownOpenStates] = useState(Array(productDetails.length).fill(false));
    const selectRefs = useRef([]);
    selectRefs.current = productDetails.map((_, index) => selectRefs.current[index] || React.createRef());



    useEffect(() => {
        if (selectedFunnel) {
            setselectedFunnelDetails(selectedFunnel);
            if (editingQuote) {
                // Populate form with existing quote data
                setUserData({
                    title: editingQuote.title || '',
                    requestPrice: editingQuote.requestedPrice || '',
                    paymentterms: editingQuote.paymentTerms || ''
                });
                setOtherTerms(editingQuote.otherDetails || '');
                setAdvPercent(editingQuote.advPercent || '50');
                setPdaPercent(editingQuote.pdaPercent || '25');
                setFnfPercent(editingQuote.fnfPercent || '25');
                setFnfTimeline(editingQuote.fnfTimeline || '');
                
                // Set delivery date
                if (editingQuote.deliveryTime) {
                    const date = new Date(editingQuote.deliveryTime);
                    setSelectedDate({
                        year: date.getFullYear(),
                        month: date.getMonth() + 1,
                        day: date.getDate()
                    });
                }
                
                // Set product details for book funnel
                if (editingQuote.productGroups && editingQuote.productGroups.length > 0) {
                    const mappedProducts = editingQuote.productGroups.map((group: any) => ({
                        productId: group.product?.id || '',
                        product: group.product,
                        quantity: group.quantity || '',
                        subject: group.subject || [],
                        class: group.class || [],
                        price: group.price || ''
                    }));
                    setProductDetails(mappedProducts);
                } else {
                    addNewProduct();
                }
            } else {
                addNewProduct();
            }
        }
    }, [selectedFunnel, editingQuote])

    const createQuoteDetails = async () => {
        console.log("createQuoteDetails called", editingQuote);
        const payload: any = {
            title : userData?.title,
            requestedPrice : userData?.requestPrice,
            paymentTerms: userData?.paymentterms || '',
            deliveryTime: Utils.convertDateToISOFormat(formatDateRange()),
            otherDetails : otherTerms,
            funnelId: selectedFunnel?.id,
            productDetails: productDetails,
            instituteId: selectedFunnel?.institute?.id,
            advPercent,
            pdaPercent,
            fnfPercent,
            fnfTimeline
        };
        
        // Add ID for update operation
        if (editingQuote) {
            payload.id = editingQuote.id;
        }

        console.log("Payload for quote:", payload);

        const res = await useCreateQuoteMutation.mutateAsync(payload);

        if (res) {
            onConfirm()
        }
    }

    const validate = () => {
        let errorMessage = '';
        if (
            !productDetails 
        ) {
            errorMessage = 'Please enter product details';
        }  else if (!userData.title) {
            errorMessage = 'Please enter quote title.';
        } else if (!userData.requestPrice) {
            errorMessage = 'Please enter requested Price.';
        } 
        // else if (!userData.paymentterms) {
        //     errorMessage = 'Please enter payment terms.';
        // }
         else if (!selectedDate) {
            errorMessage = 'Please select delivery date.';
        } else if (Number(advPercent) + Number(pdaPercent) + Number(fnfPercent) !== 100) {
            errorMessage = 'Payment percentages must add up to 100%.';
        } 
        if (errorMessage) {
            showNotification({
                type: 'info',
                title: errorMessage,
            });
            return false;
        }
        return true;
    };


    const getProductList = async () => {
        const res = await useGetUsersMutation.mutateAsync({
            page: 1,
            perPage: 100,
            search: '',
            filter: '',
        });

        //setProductList(res.list);

    };

      const formatDateRange = () => {
        return selectedDate
            ? moment({
                year: selectedDate?.year,
                month: selectedDate?.month ? selectedDate?.month - 1 : 0,
                day: selectedDate?.day,
            }).format('DD MMM YYYY')
            : 'Expected Order Date';
    };

    const addNewProduct = () => {
        setProductDetails([
            ...productDetails,
            {
                productId: '',
                name: '',
                quantity: '',
                subject: '',
                class: '',
                price: '',
            }
        ]);
    }

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.id === 'title') {
            userData.title = event.target.value;
        } else if (event.target.id === 'paymentterms') {
            userData.paymentterms = event.target.value;
        }
        else if (event.target.id === 'requestPrice') {
            userData.requestPrice = event.target.value;
        }
        setUserData({ ...userData });
    };

    const FUNNEL_TYPES = {
        BOOK_FUNNEL: '2',
        PRODUCT_FUNNEL: '1',
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const updatedStates1 = [...dropdownOpenStates1];

            selectRefs1.current.forEach((ref:any, index:any) => {
                if (ref.current && !ref.current.contains(event.target as Node)) {
                    updatedStates1[index] = false; // Close dropdown if clicked outside
                }
            });

            setDropdownOpenStates1(updatedStates1);

            const updatedStates = [...dropdownOpenStates];

            selectRefs.current.forEach((ref:any, index:any) => {
                if (ref.current && !ref.current.contains(event.target as Node)) {
                    updatedStates[index] = false; // Close dropdown if clicked outside
                }
            });

            setDropdownOpenStates(updatedStates);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownOpenStates1, dropdownOpenStates]);

    const handleMenuOpen1 = (index:any) => {
        const updatedStates = [...dropdownOpenStates1];
        updatedStates[index] = true;
        setDropdownOpenStates1(updatedStates);
    };

    const handleMenuClose = (index:any) => {
        const updatedStates = [...dropdownOpenStates];
        updatedStates[index] = false;
        setDropdownOpenStates(updatedStates);
    };

    const handleMenuOpen = (index:any) => {
        const updatedStates = [...dropdownOpenStates];
        updatedStates[index] = true;
        setDropdownOpenStates(updatedStates);
    };

    const handleMenuClose1 = (index:any) => {
        const updatedStates = [...dropdownOpenStates1];
        updatedStates[index] = false;
        setDropdownOpenStates1(updatedStates);
    };




    const CustomValueContainer1 = (props: any) => {
        const { selectProps } = props;
        const index = selectProps.index;
        return <ValueContainer1 {...props} setDropdownOpen={() => handleMenuOpen1(index)} />;
    };
    CustomValueContainer1.displayName = "CustomValueContainer1";

    const CustomValueContainer = (props: any) => {
        const { selectProps } = props;
        const index = selectProps.index;
        return <ValueContainer {...props} setDropdownOpen={() => handleMenuOpen(index)} />;
    };
    CustomValueContainer.displayName = "CustomValueContainer";



    const calculateCumulativePrice = (products: any[]) => {
        const total = products.reduce((acc, product) => {
            const price = Number(product.price || 0);
            const quantity = Number(product.quantity || 1); 
            return acc + (price * quantity);
        }, 0);
        setUserData((prevUserData: any) => ({
            ...prevUserData,
            requestPrice: total,
          }));

      };

      useEffect(() => {
        calculateCumulativePrice(productDetails);
      }, [productDetails]);

    const getContent = () => {
        return (
            <div className="add-quotes-dialog-content">
                       <div className="quotes-user-container">
                    <h1>
                        Basic Details <span>*</span>
                    </h1>
                    <div className='user-first-last-div'>
                        <input
                            className={`custome-input width-50`}
                            placeholder={'Quotation title'}
                            onChange={handleChange}
                            value={userData?.title}
                            id="title"
                        />
                           <div className="date-filter-maps">
                                <DatePicker
                                    formatInputText={formatDateRange}
                                    value={selectedDate}
                                    onChange={(newDate: any) => {
                                        if (newDate) {
                                            setSelectedDate(newDate);
                                        }
                                    }}
                                    inputPlaceholder="Expected Order Date"
                                    inputClassName='steam-rangepicker'
                                    colorPrimary="#002083"
                                    colorPrimaryLight="#002083"
                                />
                            </div>
                    </div>
                </div> 
                <div className='divider'></div>

                <div className='edit-funnel-product-details-quotes mt-4'>
                <div className='pd-title mb-2'>
                    <div className='title'>Product Details  <span>*</span> {selectedFunnel && selectedFunnel?.productGroups && selectedFunnel?.productGroups.length === 0 && <div>- Catapult</div>}</div>
                    <div className='size'>
                        {FUNNEL_TYPES.BOOK_FUNNEL === selectedFunnelDetails?.type ? <button className='steam-button invert-button' onClick={() => { addNewProduct() }}>+ Add New</button> : <div className='deal-size-edit mt-2'>
                           
                         
                        </div>}
                    </div>
                </div>
                {selectedFunnel && selectedFunnel?.productGroups && selectedFunnel?.productGroups.length > 0 && <div className='product-details-tab'>
                    <div className='product-header'>
                        <div className='name'>
                            Target Products
                        </div>
                        <div className='qty'>
                            Qty
                        </div>
                        <div className='sub'>
                            Subject
                        </div>
                        <div className='class'>
                            Class
                        </div>
                        <div className='price'>
                            Price
                        </div>

                    </div>

                    {productDetails && productDetails.length > 0 && productDetails.map((item: any, index: any) => {

                        return (
                            <div className='product-values' key={index}>
                                <div className='name'>
                                    <div className="user-first-last-div iscity-drp petsked-form">
                                        <Dropdown className="new-figma-drop-down">
                                            <Dropdown.Toggle
                                                variant="success"
                                                className="drop-down-btn funnel-drp--width dropdown-togge"
                                                id="dropdown-basic"
                                                disabled={item?.id ? true : false}
                                            >
                                                {item?.product ? item?.product?.name : 'Select product'}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="Duration-drop-down">
                                                {productList?.map((itemProd: any, prodIndex: any) => {
                                                    return (
                                                        <Dropdown.Item
                                                            key={prodIndex}
                                                            onClick={() => {
                                                                const updatedProductDetails = [...productDetails];
                                                                updatedProductDetails[index].productId = itemProd.id;
                                                                updatedProductDetails[index].product = itemProd;
                                                                updatedProductDetails[index].subject = [];
                                                                updatedProductDetails[index].class = [];
                                                                setProductDetails(updatedProductDetails);
                                                            }}
                                                            eventKey={itemProd.name}
                                                            disabled={item?.id ? true : false}
                                                        >
                                                            <div className="menu-item-minutes">{itemProd.name}</div>
                                                        </Dropdown.Item>
                                                    );
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <div className='qty'>
                                    <input
                                        className={`custome-input width-unset`}
                                        placeholder={'Qty'}
                                        onChange={(e) => {
                                            const updatedProductDetails = [...productDetails];
                                            updatedProductDetails[index].quantity = e.target.value;
                                            setProductDetails(updatedProductDetails);
                                        }}
                                        value={item.quantity}
                                        id="quantity"
                                    />
                                </div>
                                <div className='sub'>
                                    {/* <div className="table-contact  font-valeu"> */}
                                    <div className="user-first-last-div petsked-form" ref={selectRefs.current[index]}>
                                        <ReactSelect
                                            className="multiselect-react funnel-product-height"
                                            options={
                                                productList && item.productId
                                                    ? productList
                                                        .find((product: any) => product.id === item.productId)?.subject
                                                        ?.map((subject: any) => ({
                                                            value: subject.id,
                                                            label: subject.name,
                                                            name: subject.name,
                                                            id: subject.id
                                                        })) ?? []
                                                    : []
                                            }
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            classNamePrefix={'petsked-multiselect'}
                                            onChange={(selected: any) => {
                                                const updatedProductDetails = [...productDetails];
                                                updatedProductDetails[index].subject = selected.map((subject: any) => subject.value);
                                                setProductDetails(updatedProductDetails);
                                            }}
                                            getOptionLabel={(option: any) => option.name}
                                            getOptionValue={(option: any) => option.id}
                                            components={{
                                                Option,
                                                ValueContainer: CustomValueContainer,
                                            }}
                                            placeholder={'Subject'}
                                            onMenuOpen={() => handleMenuOpen(index)}
                                            onMenuClose={() => handleMenuClose(index)}
                                            menuIsOpen={dropdownOpenStates[index]}
                                            value={
                                                item.subject && item.productId
                                                    ? item.subject
                                                        .map((subjectId: string) => {
                                                            const selectedProduct = productList.find(
                                                                (product: any) => product.id === item.productId
                                                            );

                                                            const foundSubject = selectedProduct?.subject?.find(
                                                                (subj: any) => subj.id === subjectId
                                                            );

                                                            return foundSubject
                                                                ? {
                                                                    value: foundSubject.id,
                                                                    label: foundSubject.name,
                                                                    name: foundSubject.name,
                                                                    id: foundSubject.id
                                                                }
                                                                : null;
                                                        })
                                                        .filter((subject: any) => subject !== null)
                                                    : []
                                            }
                                        //  isDisabled={locationDetails.state.trim() === ''}

                                        />
                                    </div>
                                    {/* </div> */}
                                </div>
                                <div className='class'>
                                    <div onClick={() => console.log("Wrapper clicked")}  className="user-first-last-div petsked-form"  ref={selectRefs1.current[index]}>
                                        <ReactSelect
                                            className="multiselect-react funnel-product-height"
                                            options={
                                                productList && item.productId
                                                    ? productList
                                                        .find((product: any) => product.id === item.productId)?.subject
                                                        ?.filter((subject: any) => item?.subject && item.subject.length > 0 && item.subject.includes(subject.id))
                                                        .flatMap((subject: any) => subject.classes)
                                                        .map((classItem: any) => ({
                                                            value: classItem.id,
                                                            label: classItem.name,
                                                            name: classItem.name,
                                                            id: classItem.id
                                                        })) ?? []
                                                    : []
                                            }
                                            blurInputOnSelect={true}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            classNamePrefix={'petsked-multiselect'}
                                            onChange={(selected: any) => {
                                                const updatedProductDetails = [...productDetails];
                                                updatedProductDetails[index].class = selected.map((cls: any) => cls.value);
                                                setProductDetails(updatedProductDetails);
                                            }}
                                            getOptionLabel={(option: any) => option?.name}
                                            getOptionValue={(option: any) => option?.id}
                                            components={{
                                                Option: Option1,
                                                ValueContainer: CustomValueContainer1,
                                            }}
                                            placeholder={'class'}
                                            onMenuOpen={() => handleMenuOpen1(index)}
                                            onMenuClose={() => handleMenuClose1(index)}
                                            menuIsOpen={dropdownOpenStates1[index]}
                                            value={
                                                item.class && item.productId
                                                    ? item.class
                                                        .map((classId: string) => {
                                                            const selectedProduct = productList.find(
                                                                (product: any) => product.id === item.productId
                                                            );

                                                            const foundClass = selectedProduct?.subject
                                                                ?.flatMap((subj: any) => subj.classes)
                                                                ?.find((cls: any) => cls.id === classId);

                                                            return foundClass
                                                                ? {
                                                                    value: foundClass.id,
                                                                    label: foundClass.name,
                                                                    name: foundClass.name,
                                                                    id: foundClass.id
                                                                }
                                                                : null;
                                                        })
                                                        .filter((cls: any) => cls !== null)
                                                    : []
                                            }
                                            onBlur={() => {
                                                // Trigger when clicking outside
                                                console.log("Dropdown blurred");
                                            }}

                                        />
                                    </div>
                                </div>
                                <div className='price'>
                                    <input
                                        className={`custome-input width-unset`}
                                        placeholder={'Price'}
                                        onChange={(e) => {
                                            const updatedProductDetails = [...productDetails];
                                            updatedProductDetails[index].price = e.target.value;
                                            setProductDetails(updatedProductDetails);
                                        }}
                                        value={item.price}
                                        id="price"
                                    />
                                </div>
                                <div className='delete'>

                                    {index !==0 &&<Deleteicon onClick={() => {
                                        const updatedProductDetails = productDetails.filter((_, i) => i !== index);
                                        setProductDetails(updatedProductDetails);
                                    }} />}
                                </div>
                            </div>
                        )
                    })}
 <div className='deal-size-edit mt-2'>
                <div className='title'>
                Total Order Value
                </div>
                <div className='input-data'>
                    <input
                        className={`custome-input width-150`}
                        placeholder={'Deal size'}
                        onChange={handleChange}
                        value={userData?.requestPrice}
                        id="requestPrice"
                    />
                </div>

            </div>




                </div>}

                {FUNNEL_TYPES.PRODUCT_FUNNEL === selectedFunnelDetails?.type && 
                <div className='product-details-tab'>
                     <div className='deal-size-edit mt-2'>
                     <div className='title'>
                     Total Order Value
                     </div>
                     <div className='input-data'>
                         <input
                             className={`custome-input width-150`}
                             placeholder={'Deal size'}
                             onChange={handleChange}
                             value={userData?.requestPrice}
                             id="requestPrice"
                         />
                     </div>
     
                 </div>
                 </div>
                }

            </div>
            <div className='divider'></div>
            
            <div className="quotes-user-container">
                <h1>
                    Payment Percentage <span>*</span>
                </h1>
                <div className='percentage-row'>
                    <div className='percentage-field'>
                        <label className='percentage-label'>ADV %</label>
                        <input
                            className='custome-input percentage-input'
                            placeholder='50'
                            value={advPercent}
                            onChange={(e) => setAdvPercent(e.target.value)}
                            type='number'
                        />
                    </div>
                    <div className='percentage-field'>
                        <label className='percentage-label'>PDA %</label>
                        <input
                            className='custome-input percentage-input'
                            placeholder='25'
                            value={pdaPercent}
                            onChange={(e) => setPdaPercent(e.target.value)}
                            type='number'
                        />
                    </div>
                    <div className='percentage-field'>
                        <label className='percentage-label'>FNF %</label>
                        <input
                            className='custome-input percentage-input'
                            placeholder='25'
                            value={fnfPercent}
                            onChange={(e) => setFnfPercent(e.target.value)}
                            type='number'
                        />
                    </div>
                </div>
                
                <h2>
                    FNF Timeline - Days after delivery <span></span>
                </h2>
                <div className='user-first-last-div' style={{paddingTop:'8px'}}>
                    <input
                        className='custome-input width-50'
                        placeholder='Enter days'
                        value={fnfTimeline}
                        onChange={(e) => setFnfTimeline(e.target.value)}
                        type='number'
                    />
                </div>
            </div>
            <div className='divider'></div>

            <div className="quotes-user-container">
                    {/* <h1>
                        Payment Details <span>*</span>
                    </h1> */}
                    {/* <div className='user-first-last-div'> */}
                        {/* <input
                            className={`custome-input width-50`}
                            placeholder={'Request price'}
                            onChange={handleChange}
                            value={userData?.requestPrice}
                            id="requestPrice"
                        /> */}
                          {/* <input
                            className={`custome-input`}
                            placeholder={'Payment Breakup'}
                            onChange={handleChange}
                            value={userData?.paymentterms}
                            id="paymentterms"
                        /> */}
                    {/* </div> */}
                    <h2>
                        Other Remarks <span></span>
                    </h2>
                    <div className='user-first-last-div'>
                        <textarea
                            className="new-cust-input message-input-funnel-1"
                            placeholder="Describe any specific requirement.."
                            onChange={(ev) => setOtherTerms(ev.target.value)}
                            value={otherTerms}
                        />
                    </div>
                </div> 
                <div className='divider'></div>
            </div>
        );
    };

    return (
        <>
            <Modal
                show={open}
                onHide={() => { onClose() }}
                className={`steam-modal-dialog add-quotes-dialog `}
                size="sm"

            >
                <Modal.Header closeButton >
                    <div className="model-header-tab">
                        <div className="modal-header-title">
                            {editingQuote ? 'Update quotation' : 'Request quotation'}
                        </div>
                        <div className="modal-header-desc">
                            {/* {'Lorem ipsum dolor sit amet, consectetur elit, sed'} */}
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body >{getContent()}</Modal.Body>
                <ModalFooter>
                    <div className={`btn-container end`}>
                        <button
                            className={`steam-button button-dark set-height`}
                            onClick={async () => {
                                    
                                if(validate()){
                                    createQuoteDetails()
                                }
                                
                            }}
                        //disabled={useAddInstituteMutation?.isLoading}
                        >
                            <span>{editingQuote ? 'Update' : 'Submit'}</span>
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};



const Option1 = (props: any) => {
    const {
        data: { avatarUrl, name, email },
        isSelected,
        selectOption,
    } = props;

    const handleOptionClick = (e: React.MouseEvent) => {
        e.preventDefault(); 
        e.stopPropagation(); 
        selectOption(props.data);
    };

    return (
        <div key={`options-sp${props.value}`}  onMouseDown={handleOptionClick} >
            <components.Option {...props}>
                <div
                    className="service-provider-option funnelsubject-width"
                   
                >
                    <div className="left-details">
                        <span>
                            <label className="name">{name}</label>
                        </span>
                    </div>
                    <div>
                        <label htmlFor={`option-check-${props.value}`} className="check-container">
                            <input
                                checked={isSelected}
                                id={`option-check-${props.value}`}
                                type="checkbox"
                                readOnly
                            />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                </div>
            </components.Option>
        </div>
    );
};




const Option = (props: any) => {
    const {
        data: { avatarUrl, name, email },
        isSelected,
        selectOption,
    } = props;


    const handleOptionClick = (e: React.MouseEvent) => {
        e.preventDefault(); 
        e.stopPropagation(); 
        selectOption(props.data);
    };

    return (
        <div key={`options-sp${props.value}`} onMouseDown={handleOptionClick}>
            <components.Option {...props}>
                <div className="service-provider-option funnelsubject-width">
                    <div className="left-details">
                        {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
                        <span>
                            <label className="name">{name}</label>
                            {/* <label className="email">{email}</label> */}
                        </span>
                    </div>
                    <div>
                        <label htmlFor={`option-check-${props.value}`} className="check-container">
                        <input
                                checked={isSelected}
                                id={`option-check-${props.value}`}
                                type="checkbox"
                                readOnly
                            />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                </div>
            </components.Option>
        </div>
    );
};
const ValueContainer = (props: any) => {
    const { setDropdownOpen } = props; 
    const valueLength = props.getValue().length;
    return (
        <components.ValueContainer {...props} onClick={() => setDropdownOpen(true)}>
            {valueLength === 0 && <span className="react-select-custom-placeholder funnel-filter-height ">subject</span>}
            {props.getValue().length > 0 &&
                !props.selectProps.inputValue &&
                `+${valueLength}`}
            {/* {React.Children.map(props.children, (child) => {
                return child.type === components.Input ? child : null;
            })} */}
        </components.ValueContainer>
    );
};



const ValueContainer1 = (props: any) => {
    const { setDropdownOpen } = props; 
    const valueLength = props.getValue().length;

    return (
        <components.ValueContainer {...props} onClick={() => setDropdownOpen(true)}>
            {valueLength === 0 && <span className="react-select-custom-placeholder funnel-filter-height">class</span>}
            {props.getValue().length > 0 &&
                !props.selectProps.inputValue &&
                `+${valueLength}`}
            {/* {React.Children.map(props.children, (child) => {
                return child.type === components.Input ? child : null;
            })} */}
        </components.ValueContainer>
    );
};





export default AddQuotesDialog;
